import Icon from '../components/Icon';

const Facebook = Icon(
  'facebook',
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.977 11.988C23.977 5.368 18.609 0 11.988 0 5.368 0 0 5.367 0 11.988c0 5.984 4.384 10.944 10.115 11.843v-8.377H7.071v-3.466h3.044v-2.64c0-3.005 1.79-4.665 4.528-4.665 1.312 0 2.684.234 2.684.234v2.95h-1.512c-1.49 0-1.954.924-1.954 1.872v2.25h3.325l-.531 3.465H13.86v8.377c5.732-.9 10.116-5.859 10.116-11.843"
    />
  </>
);

export default Facebook;
